import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthModal from "@/components/site/AuthModal";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    document.title =
      "NK Science & Physics Academy | Best Tuition Centre in Hajo, Kamrup";
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
          <div className="App bg-paper">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <AuthModal />
            <Toaster position="top-center" richColors />
          </div>
        </ReactLenis>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
